module.exports = __webpack_public_path__ + "static/img/icon7.8eeec20b.png";